export async function getTransactions(client, { address, offset, limit, lastBlock }) {
    const data = await client.request({
        method: 'getTransactions',
        params: {
            address,
            offset,
            limit,
            lastBlock,
        },
    });
    return data;
}
//# sourceMappingURL=getTransactions.js.map